import React from 'react';
import { AuthResult } from '../../Auth';
import { UserPersona } from '../UserPersona';

interface AdminHeaderProps {
    authResponse: AuthResult | null;
    onLogoClick: () => void;
    onLogout: () => void;
    theme: any;
    styles: any;
}

export const AdminHeader: React.FC<AdminHeaderProps> = ({
    authResponse,
    onLogoClick,
    onLogout,
    theme,
    styles
}) => {
    return (
        <div className={styles.headerSection}>
            <div className={styles.logoSection}>
                <img
                    className={styles.logo}
                    src="https://taxisever.cz/wp-content/uploads/2024/02/website_logo_transparent_background-300x146.png"
                    alt="Taxi Sever"
                    onClick={onLogoClick}
                    title="Zpět na hlavní stránku"
                />
                <div>
                    <h1 className={styles.title}>Administrace</h1>
                    <span className={styles.subtitle}>Správa knihy jízd</span>
                </div>
            </div>

            {authResponse !== null && (
                <UserPersona email={authResponse.email} onLogout={onLogout} />
            )}
        </div>
    );
};
